import { render } from "./FooterDisplay.vue?vue&type=template&id=13095026&scoped=true"
import script from "./FooterDisplay.vue?vue&type=script&lang=js"
export * from "./FooterDisplay.vue?vue&type=script&lang=js"

import "./FooterDisplay.vue?vue&type=style&index=0&id=13095026&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13095026"]])

export default __exports__